import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";
import "./styles.css";
import { Container, Box, VStack, Center, Text, Flex, Spacer, Image } from "@chakra-ui/react"

import logo3dsmax from '../images/logo3dsmax.png';
import logoAe from '../images/logoAe.png';
import logoAi from '../images/logoAI.png';
import logoAu from '../images/logoAu.png';
import logoCSS from '../images/logoCSS.png';
import logoFigma from '../images/logoFigma.png';
import logoGreensock from '../images/logoGreensock.png';
import logoHTML from '../images/logoHTML.png';
import logoJavascript from '../images/logoJavascript.png';
import logoLottie from '../images/logoLottie.png';
import logoPsd from '../images/logoPsd.png';
import logoPython from '../images/logoPython.png';
import logoReact from '../images/logoReact.png';
import logoThreejs from '../images/logoThreejs.png';
import logoTypescript from '../images/logoTypescript.png';



gsap.registerPlugin(ScrollTrigger);

export default function HScrolling() {
  const panels:any = useRef([]);
  const panelsContainer:any = useRef();

  const createPanelsRefs = (panel:any, index:any) => {
    panels.current[index] = panel;
  };

  useEffect(() => {
    const totalPanels = panels.current.length;

    gsap.to(panels.current, {
      xPercent: -100 * (totalPanels - 1),
      ease: "none",
      scrollTrigger: {
        trigger: panelsContainer.current,
        pin: true,
        scrub: true,
        markers: false,
        
        // base vertical scrolling on how wide the container is so it feels more natural.
        end: () => "+=" + panelsContainer.current.offsetWidth
      }
    });
  }, []);

  return (
    <><Box id='skills' zIndex='2'/>
      <Box className="container" ref={panelsContainer}>
        <Box 
          className="description panel blue"
          ref={(e) => createPanelsRefs(e, 0)}
        >
          <VStack spacing={50}>
            <Box fontWeight="extrabold" fontSize="50px" color='gray.100' paddingTop='85px'>
              FRAMEWORK
            </Box>
            <Center padding='20px' bg='gray.100'>
              <Image w='15%' h='15%' src={logoPython} />
              <Image w='15%' h='15%' src={logoFigma} />
              <Image w='15%' h='15%' src={logoReact} />
              <Image w='15%' h='15%' src={logoTypescript} />
              <Image w='15%' h='15%' src={logoJavascript} />
            </Center>
            <Box paddingInline='100px' textAlign='left' color='gray.100' fontWeight='light' fontSize='24px'>
              With JavaScript as its basis, we're building this website using React Framework + Typescript.
              <br/>But I also learned Python for Back-end Logic and figma for Prototyping.
            </Box> 
          </VStack>
        </Box>
        <Box className="panel red" ref={(e) => createPanelsRefs(e, 1)}>
        <VStack spacing={50}>
            <Box fontWeight="extrabold" fontSize="50px" color='red.100'>
              API
            </Box>
            <Center padding='20px' bg='red.200'>
              <Image w='15%' h='15%' src={logoLottie} opacity={0}/>
              <Image w='15%' h='15%' src={logoLottie} />
              <Image w='15%' h='15%' src={logoThreejs} />
              <Image w='15%' h='15%' src={logoGreensock} />
              <Image w='15%' h='15%' src={logoLottie} opacity={0}/>
            </Center>
            <Box paddingInline='100px' textAlign='left' color='red.100' fontWeight='light' fontSize='24px'>
              All the fun stuff (3D Visual, Animation, Horizontal Scroll) comes from API.
            </Box> 
          </VStack>
        </Box>
        <Box className="panel orange" ref={(e) => createPanelsRefs(e, 2)}>
          <VStack spacing={50}>
            <Box fontWeight="extrabold" fontSize="50px" color='yellow.100'>
              DESIGN
            </Box>
            <Center padding='20px' bg='yellow.100'>
              <Image w='10%' h='10%' src={logo3dsmax} />
              <Image w='15%' h='15%' src={logoAe} />
              <Image w='15%' h='15%' src={logoPsd} />
              <Image w='15%' h='15%' src={logoAi} />
              <Image w='15%' h='15%' src={logoAu} />
            </Center>
            <Box paddingInline='100px' textAlign='left' color='yellow.100' fontWeight='light' fontSize='24px'>
              I got 3D Design background, so it's sugoi to have Design App in my inventory.
            </Box> 
          </VStack>
        </Box>
      </Box>
      {/* Fun things from this website (3D Visual, Interaction and Horizontal Scrolling) is coming from API. */}
    </>
  );
}
